import { useLocation } from 'react-router-dom';
import { LifeGenericResultRery } from '../../components';
import { useTranslation } from 'react-i18next';

export const ChangeRequestErrorpage = () => {
  const { t } = useTranslation();
  const location = useLocation() as {
    state: {
      defaultTo?: string;
      defaultLabel?: string;
    };
  };
  return (
    <LifeGenericResultRery
      title={t('common.requestLoadError')}
      defaultTo={location?.state?.defaultTo}
      defaultLabel={location?.state?.defaultLabel}
    />
  );
};
